// extracted by mini-css-extract-plugin
module.exports = {"container":"container__bcilF","documentLabeler":"documentLabeler__-AV1e"};